import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=bb4ac8c6&"
import script from "./Code.vue?vue&type=script&lang=js&"
export * from "./Code.vue?vue&type=script&lang=js&"
import style0 from "./Code.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb4ac8c6')) {
      api.createRecord('bb4ac8c6', component.options)
    } else {
      api.reload('bb4ac8c6', component.options)
    }
    module.hot.accept("./Code.vue?vue&type=template&id=bb4ac8c6&", function () {
      api.rerender('bb4ac8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Code.vue"
export default component.exports